export default {
  title: 'Clauses',
  accept: 'I accept the conditions',
  key: 'Signature key'
}
